import { Container } from 'react-bootstrap'
import React from 'react'
import { ForgotPass } from './ForgotPass'
import { NewForgotPass } from './NewForgotPass'

const country = process.env.REACT_APP_COUNTRY;

export const PageForgotPass = () => {
  return (
    <div>
      <img src={"https://raw.githubusercontent.com/RamiroSB/imagenes/main/rma-banner.png"} alt="Imagen marcas" className='imagenesBody' loading='lazy'></img>
      <Container>
        {country === 'ARG' || country === 'DO' || country === 'USA' || country === 'PY' || country === 'CL' || country === 'HN' || country === 'SV' || country === 'PA' || country === 'GT' || country === 'DO' || country === 'USA' || country === 'CR' || country === 'UY' ? <NewForgotPass /> : <ForgotPass />}
      </Container>
    </div>
  )
}